import Club from '@/orm/models/Club'
import CtlClass from '@/orm/models/CtlClass'
import CtlNomination from '@/orm/models/CtlNomination'
import Venue from '@/orm/models/Venue'
import { dateRange } from '@/utils/dateUtils'
import { Model } from 'pinia-orm'
import { DateCast } from 'pinia-orm/casts'
import { Str, Num, Bool, BelongsTo, Cast, Attr, HasMany, OnDelete } from 'pinia-orm/decorators'

export default class Ctl extends Model {
    static entity = 'ctls'

    @Num(0, { notNullable: true })
    declare id: number
    @Str('', { notNullable: true })
    declare name: string
    @Num(null)
    declare clubId: number | null
    @BelongsTo(() => Club, 'clubId')
    declare club: Club | null
    @Str(null)
    declare organizer: string | null
    @Num(null)
    declare venueId: number | null
    @BelongsTo(() => Venue, 'venueId')
    declare venue: Venue | null
    @Str(null)
    declare otherVenue: string | null
    @Cast(() => DateCast) @Attr('')
    declare from: string
    @Cast(() => DateCast) @Attr(null)
    declare to: string | null
    @Num(null)
    declare days: number | null
    @Str(null)
    declare registrationUrl: string | null
    @Str(null)
    declare noticeboardUrl: string | null
    @Str(null)
    declare description: string | null
    @Bool(false)
    declare cancelled: boolean
    @HasMany(() => CtlClass, 'ctlId') @OnDelete('cascade')
    declare classes: CtlClass[]
    @HasMany(() => CtlNomination, 'ctlId') @OnDelete('cascade')
    declare nominations: CtlNomination[]
    @Num(1)
    declare courses: number

    get dateRange(): string {
        return dateRange(this.from, this.to)
    }

    static piniaOptions = {
        persist: true,
    }
}
